module.exports = __webpack_public_path__ + "img/product_banner_04.aa3eb480.jpg";